import { Component, OnInit,ViewChild,ElementRef } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, NgForm } from '@angular/forms';
import * as XLSX from 'xlsx';

import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { ApiLoginService } from '@app/api/api-login.service';
import { ApiContentService } from '@app/api/api-content.service';
import { ApiPartnerService } from '@app/api/api-partner.service';
import { LoadJsService } from '../../load-js/load-js.service';

@Component({
  selector: 'app-order-list',
  templateUrl: './order-list.component.html',
  styleUrls: ['./order.component.css']
})
export class OrderListComponent implements OnInit {
  @ViewChild("fileUploader", { static: false })
  fileUploader: ElementRef;

  constructor(
    public restApi:ApiPartnerService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private login: ApiLoginService,
    public partnerService: ApiPartnerService,
    public LoadJsOrder: LoadJsService,
  ) { }

  formView = this.fb.group({
    id : ['']
  });
  form_upload = this.fb.group({
    type : [''],
    name_file: [''],
    value_upload: ['']
  });

  formOrder = this.fb.group({
    partnerid: [''],
    tgl_order: [''],
    grf_number: [''],
    iom_number: [''],
    value_upload: ['']
  })
  formOrderReupload = this.fb.group({
    value_upload: [''],
    id: ['']
  })
  btn_save = true
  btn_loading = false
  loading_create = false
  alert_failed = false
  alert_success = false

  table_load = false
  table_data = false
  form_create = false
  
  listorder:any=[]
  partnername:any=[]

  data_order_service:any={}
  data_partner:any={}
  response_api:any={}

  paging : any = {};
  msearch : string;
  //paging_link : any = [];
  page_self = [];
  page_next = [];
  page_prev = [];
  meta = [];
  last_index : number;
  first_index : number;
  total_count : number;
  querySearch = false;
  searching = false;
  dataempty = true;
  currentParams = {};
  queryParams = '';
  searchQueryParams = '';
  href='';

  ngOnInit() {
    this.loadStart();
  }
  
  loadStart() {
    this.route.queryParams
      //.filter(params => params.order)
      .subscribe(params => {
        console.log(params); // {order: "popular"}

        //this.order = params.order;
        //console.log(this.order); // popular

        if (params.search != '' && params.search != undefined ){
          console.log('search');
          console.log(params.search);
         this.msearch = params.search; 
         this.querySearch = true;
        

         this.currentParams = params;
         this.queryParams = '?'+this.queryStr(params);
         this.getListorder(this.queryParams);
        
        }else{
          this.querySearch = false;
          this.currentParams = params;

          this.queryParams = '?'+this.queryStr(params);
          console.log(this.queryParams);
          console.log(this.queryStr(params));
          /* pagination */
          //this.loadworkorder(this.currentParams);
          this.getListorder(this.queryParams);
        }
      });
    this.LoadJsOrder.loadScriptOrderStb()
    // this.getListorder();
    this.partner()
  }

  refreshPage() {
    this.table_data = false
    this.loadStart()
  }

  queryStr(options: any){
    let params = new URLSearchParams();
    for(let key in options){
        params.set(key, options[key]) 
    }
    return params.toString();
  }

  search()
  {
    this.querySearch = true;
    this.searchQueryParams = this.queryParams+'&search='+this.msearch;
    this.getListorder(this.searchQueryParams);
  }

  getListorder(params: any){
    this.table_data = false
    this.table_load = true
    this.restApi.GetListorder(params).subscribe((output: any) => {
      this.listorder = output.data
      this.partnername = output.partnername
      console.log(output)
      this.table_load = false
      this.table_data = true

      // start pagination
      this.paging = output.pagex;
      this.page_self = output.pagex.self;
      this.page_next = output.pagex.next;
      this.page_prev = output.pagex.prev;
      this.meta = output.meta;
      this.total_count = this.meta['totalCount'];
      let self = this.page_self['page'];
      if ( self * this.meta['perPage'] < this.meta['totalCount']){
        this.last_index = (self * this.meta['perPage']);
      }else{
        this.last_index = this.meta['totalCount'];
      }
      
      this.first_index = ((self-1)*this.meta['perPage'])+1;
      //end pagination
    })
  }

  partner() {
    this.restApi.GetPartner().subscribe((data: {}) => { 
      this.data_partner = data
      // console.log(this.data_order_service)
    });  
  }
  getView(id: any) {
    this.restApi.ViewOrderService(id)
      .subscribe((data: {}) => { 
        this.response_api = data
        console.log(this.response_api)
      }
    );
  }

  back() {
    this.form_create = false;
  }

  reset(form: NgForm){
    form.reset(); // or form.resetForm();
  }
}

